import { Box, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { PaddingBox } from '~components/atoms';
import { FieldInfo } from '~components/molecules';
import {
  usePinningStepContext,
  useVenuePlacementCreationContext,
} from '~providers';
import type { IFormCreationValues } from '~providers/useForm';
import { formatContactName } from '~utils/normalize.util';

export const VenueDetailReviewStep: React.FC = () => {
  const { existingVenueDetail } = useVenuePlacementCreationContext();
  const { contactSkippedStep } = usePinningStepContext();
  const { values } = useFormikContext<IFormCreationValues>();

  // Values typed before Skip stay in the form for Back but are not submitted
  const newVenueContact = !contactSkippedStep
    ? values.venue.venueContact
    : undefined;
  const venueContact = existingVenueDetail
    ? existingVenueDetail.venueContact
    : newVenueContact;

  return (
    <>
      <PaddingBox
        flex={1}
        sx={{
          bgcolor: 'background.paper',
          width: '100%',
          height: '100%',
        }}
      >
        <Box display="flex" flexDirection="column" gap={4} width="100%">
          {/* Venue Pinning Info */}
          <Stack gap={1}>
            <Typography variant="h5" color="text.black">
              {existingVenueDetail?.locationName || values.venue.locationName}
            </Typography>
            <FieldInfo
              label="Venue Type"
              value={
                existingVenueDetail?.venueTypeName ||
                values.venue.venueType?.name ||
                '---'
              }
            />
            <FieldInfo
              label="Venue Sub-Type"
              value={
                existingVenueDetail?.venueSubTypeName ||
                values.venue.venueSubType?.name ||
                'None'
              }
            />
            <FieldInfo
              label="Address"
              value={
                existingVenueDetail?.addressLine1 ||
                values.venue.address?.name ||
                '---'
              }
            />
          </Stack>

          {/* Venue Contact Info */}
          <Stack gap={1}>
            <Typography variant="h5" color="text.dark">
              Venue's contact
            </Typography>
            <FieldInfo label="Name" value={formatContactName(venueContact)} />
            <FieldInfo label="Email" value={venueContact?.email || '---'} />
            <FieldInfo
              label="Phone Number"
              value={venueContact?.phone || '---'}
            />
            <FieldInfo
              label="Title / Role"
              value={venueContact?.role || '---'}
            />
          </Stack>
        </Box>
      </PaddingBox>
    </>
  );
};
